import { useEffect, useRef } from 'react';

import { isNarrativeDownloadDataReady } from '../../../../../../components/NarrativeFlowView/utilities/helpers';

interface NarrativePptExportObserverProps {
  hookData?: {
    downloadData?: any;
    error?: any;
    flow?: any;
  };
  onExportError: () => void;
  onExportReady: ({
    downloadData,
    flowData,
    request,
  }: {
    downloadData: any;
    flowData: any;
    request: NarrativePptExportRequest;
  }) => void;
  request?: NarrativePptExportRequest;
}

interface NarrativePptExportRequest {
  flowId?: number | string;
}

const NarrativePptExportObserver = ({
  hookData,
  onExportError,
  onExportReady,
  request,
}: NarrativePptExportObserverProps) => {
  const hasTriggeredRef = useRef(false);

  useEffect(() => {
    hasTriggeredRef.current = false;
  }, [request?.flowId]);

  useEffect(() => {
    if (!request?.flowId || hasTriggeredRef.current) return;
    if (hookData?.error) {
      hasTriggeredRef.current = true;
      onExportError();
      return;
    }
    if (
      !isNarrativeDownloadDataReady({
        downloadData: hookData?.downloadData,
        flowData: hookData?.flow,
      })
    ) {
      return;
    }
    if (!hookData) return;
    hasTriggeredRef.current = true;

    onExportReady({
      downloadData: hookData.downloadData,
      flowData: hookData.flow,
      request,
    });
  }, [hookData, onExportError, onExportReady, request]);

  return null;
};

export default NarrativePptExportObserver;
